module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-1f8f4e.1225d7d4.png";